import React, {useState} from "react";

const SixDigitInput = ({values, setValues, small}) => {
  // const [values, setValues] = useState(new Array(6).fill(""));

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newValues = [...values];
      newValues[index] = value;
      setValues(newValues);

      // Move to next input if there's a value
      if (value && index < 5) {
        document.getElementById(`digit-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !values[index] && index > 0) {
      document.getElementById(`digit-${index - 1}`).focus();
    }
  };

  return (
    <div
      className={`flex ${
        small ? "gap-2" : "gap-5"
      }  max-[500px]:gap-2 justify-center items-center`}
    >
      {values.map((digit, index) => (
        <input
          key={index}
          id={`digit-${index}`}
          type="text"
          maxLength={1}
          className={`  ${
            small ? "w-14" : "w-16"
          }   max-[500px]:w-10 aspect-square   text-center text-2xl border-2 border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500`}
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
        />
      ))}
    </div>
  );
};

export default SixDigitInput;
